import { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import {
	Column,
	Toast,
	Button,
	Dialog,
	InputText,
	InputTextarea,
	TabView,
	TabPanel,
	tabHeaderIIespanol,
	Calendar,
	tabHeaderIIingles,
	Dropdown,
	Divider,
} from "../../components/crud";
import { Conexion } from "../../service/Conexion";
import {
	TablaDatos,
	BarraSuperior,
	EliminarVentana,
	productDialogFooter,
} from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { setDataSet, setFormData } from "../../store/appSlice";
import { Cargando } from "../../components/crud/Cargando";
import { ImagenCampo } from "../../components/crud/ImagenCampo";
import { Carousel } from "primereact/carousel";
import { Leerqr } from "../../components/crud/Leerqr";
// import { QrReader } from "react-qr-reader";
// import { ImagenCampo } from "../../components/crud/ImagenCampo";

// leonardo

export const AgendaMantenimiento = () => {
	const TABLA = "agendamantenimiento";
	let emptyFormData = {};
	const { dataSet, formData } = useSelector((state) => state.appsesion); //datos el storage redux
	const dispatch = useDispatch();
	const [productDialog, setProductDialog] = useState(false);
	const [deleteProductDialog, setDeleteProductDialog] = useState(false);
	const [submitted, setSubmitted] = useState(false);
	const toast = useRef(null);
	const [recargar, setrecargar] = useState(0);
	const [cargando, setCargando] = useState(false);
	const datatable = new Conexion();
	// const [
	// 	dropdowvnDepartamentos,
	// 	setdropdowndropdowvnDepartamentos,
	// ] = useState(null);

	// const [dropdowvnClientes, setdropdowndropdowvnClientes] = useState(null);
	// const [dropdowvnMunicipios, setdropdowvnMunicipios] = useState(null);
	// const [listaMunicipios, setlistaMunicipios] = useState(null);
	const [products, setProducts] = useState([]);
	const [qrData, setqrData] = useState([]);
	const [openqr, setopenqr] = useState(false);
	let tituloiter = "Agenda";

	useEffect(() => {
		//cargar la data total
		setCargando(true);
		dispatch(setFormData(emptyFormData));

		datatable.gettable(TABLA).then((data) => {
			dispatch(setDataSet(data));
			setCargando(false);
		});

		// datatable
		// 	.gettable("parametros/departamentos")
		// 	.then((menu) => setdropdowndropdowvnDepartamentos(menu));

		// datatable
		// 	.gettable("parametros/cliente")
		// 	.then((menu) => setdropdowndropdowvnClientes(menu));

		// datatable
		// 	.gettable("parametros/municipios")
		// 	.then((menu) => setlistaMunicipios(menu));
	}, [recargar]);

	useEffect(() => {
		// console.log("mi efecto detalle galeria", formData);
		saveImagenDetalle();
		let _product = { ...formData };
		// if (_product.hasOwnProperty("img_detalle")) {
		// 	delete _product.img_detalle;
		// }
	}, [formData]);

	// useEffect(() => {
	// 	if (formData.cod_ciu_sed) {
	// 		const municipiosFiltrados = listaMunicipios.filter(
	// 			(item) => item.cod_dep_mun === formData.cod_ciu_sed // Comparación estricta
	// 		);
	// 		setdropdowvnMunicipios(municipiosFiltrados);
	// 		// console.log(municipiosFiltrados);
	// 	}
	// }, [formData.cod_ciu_sed]);

	/*eventos*/
	const openNew = () => {
		dispatch(setFormData(emptyFormData));
		setSubmitted(false);
		setProductDialog(true);
		setProducts([]);
	};
	const hideDialog = () => {
		setSubmitted(false);
		setProductDialog(false);
	};

	const hideDeleteProductDialog = () => {
		setDeleteProductDialog(false);
	};

	const editProduct = (id) => {
		setCargando(true);
		datatable
			.getItem(TABLA, id)
			.then((data) => dispatch(setFormData({ ...data.data })));
		setProductDialog(true);
		setCargando(false);
		datatable
			.gettable("parametros/galeriaimagenesdetalle/" + id)
			.then((datos) => {
				// console.table(datos);
				setProducts(datos);
				setCargando(false);
			});
	};

	const confirmDeleteProduct = (fila) => {
		dispatch(setFormData(fila));
		setDeleteProductDialog(true);
	};
	const trasaccionExitosa = (tipo = "") => {
		setrecargar(recargar + 1);
		tipo === "borrar" ? setDeleteProductDialog(false) : hideDialog();
		dispatch(setFormData(emptyFormData));

		toast.current.show({
			severity: "success",
			summary: "Confirmacion",
			detail: "Transacción Exitosa",
			life: 4000,
		});
	};

	const saveImagenDetalle = () => {
		// console.log("entro a insertar detalle");
		setSubmitted(true);
		if (formData.img_detalle?.trim()) {
			setCargando(true);
			if (formData.id) {
				//nuevo registro
				datatable
					.getCrearItem("galeriaimagenesdetalle", formData)
					.then((data) => {
						setCargando(false);
						// console.log("llego al final");

						datatable
							.gettable(
								"parametros/galeriaimagenesdetalle/" +
									formData.id
							)
							.then((datos) => {
								// console.table(datos);
								// console.log(datos.length);
								let _product = { ...formData };

								// Eliminar el elemento "img_detalle"
								if (_product.hasOwnProperty("img_detalle")) {
									delete _product.img_detalle;
									dispatch(setFormData(_product));
								}

								setProducts(datos);
								setCargando(false);
							});
					});
			}
		}
	};

	/*eventos*/

	/**operacion transacciones */
	const saveProduct = () => {
		// console.log("save");
		// console.log(formData.nom_cli);
		setSubmitted(true);
		if (formData.cod_equ_ama?.trim()) {
			// console.log(formData);
			// debugger
			setCargando(true);
			if (formData.id == null) {
				//nuevo registro
				datatable
					.getCrearItem(TABLA, formData)
					.then((data) => trasaccionExitosa());
			} else {
				//editar registro
				datatable
					.getEditarItem(TABLA, formData, formData.id)
					.then((data) => trasaccionExitosa());
			}
		}
	};

	const deleteProduct = () =>
		datatable
			.getEliminarItem(TABLA, formData, formData.id)
			.then((data) => trasaccionExitosa("borrar"));
	/**operacion transacciones */

	/* validaciones de campos */
	const onInputChange = (e, name) => {
		const val = (e.target && e.target.value) || "";
		let _product = { ...formData };
		_product[`${name}`] = val;
		// console.log(_product);
		dispatch(setFormData(_product));
	};

	const onInputChangeDate = (e, name) => {
		const val = e.value.toISOString().split("T")[0] || "";
		let _product = { ...formData };
		_product[`${name}`] = val;
		dispatch(setFormData(_product));
	};

	const actionBodyTemplate = (rowData) => {
		return (
			<div
				className='actions'
				style={{
					display: "flex",
				}}>
				<Button
					icon='pi pi-pencil'
					className='p-button-rounded p-button-success mr-2'
					onClick={() => editProduct(rowData.id)}
				/>
				<Button
					icon='pi pi-trash'
					className='p-button-rounded p-button-warning mr-2'
					onClick={() => confirmDeleteProduct(rowData)}
				/>
			</div>
		);
	};

	const responsiveOptions = [
		{
			breakpoint: "480px",
			numVisible: 2,
			numScroll: 2,
		},
		{
			breakpoint: "480px",
			numVisible: 2,
			numScroll: 2,
		},
		{
			breakpoint: "480px",
			numVisible: 1,
			numScroll: 1,
		},
	];

	const productTemplate = (product) => {
		// console.log(product);
		return (
			<div className='product-item'>
				<div className='product-item-content'>
					<div className='mb-1'>
						<img
							src={`${product.img_dal}`}
							onError={(e) =>
								(e.target.src =
									"https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png")
							}
							alt={product.name}
							className='product-image'
						/>
					</div>
					<div>
						<div className='car-buttons mt-2'>
							<Button
								icon='pi pi-trash'
								className='p-button p-button-rounded mr-2'
								onClick={() => borrarImagen(product.cod_dga)}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	};

	const borrarImagen = (idImagen) => {
		setCargando(true);
		setProducts([]);
		datatable
			.getEliminarItem("galeriaimagenesdetalle", formData, idImagen)
			.then((data) =>
				datatable
					.gettable(
						"parametros/galeriaimagenesdetalle/" + formData.id
					)
					.then((datos) => {
						// console.table(datos);
						// console.log(datos.length);
						setProducts(datos);
						setCargando(false);
					})
			);
	};

	const tipodeagenda = [
		{ name: "Preventivo", code: "Preventivo" },
		{ name: "Correctivo", code: "Correctivo" },
		{ name: "Instalacion", code: "Instalacion" },
		{ name: "Dar de baja", code: "Dar de baja" },
	];
	const statusagenda = [
		{ name: "Pendiente", code: "Pendiente" },
		{ name: "Ejecutado", code: "Ejecutado" },
		{ name: "Cancelado", code: "Cancelado" },
	];

	const openReedQR = () => {
		setqrData(null);
		setopenqr(true);
	};

	return (
		<div className='grid'>
			<div className='col-12'>
				<div className='card'>
					<Cargando cargando={cargando} />
					<Toast ref={toast} />
					<BarraSuperior openNew={openNew} />
					<TablaDatos Datos datostabla={dataSet} titulo={tituloiter}>
						<Column
							field='fec_ama'
							header='Fecha'
							sortable
							headerStyle={{
								width: "15%",
								minWidth: "10rem",
							}}></Column>
						<Column
							field='nom_cli'
							header='Cliente'
							sortable
							headerStyle={{
								width: "30%",
								minWidth: "10rem",
							}}></Column>

						<Column
							field='cod_equ_ama'
							header='Equipo'
							sortable
							headerStyle={{
								width: "15%",
								minWidth: "10rem",
							}}></Column>

						<Column
							field='tip_ama'
							header='Tipo'
							sortable
							headerStyle={{
								width: "20%",
								minWidth: "10rem",
							}}></Column>

						<Column
							field='sta_ama'
							header='Status'
							sortable
							headerStyle={{
								width: "20%",
								minWidth: "10rem",
							}}></Column>

						<Column
							header='Acciones'
							body={actionBodyTemplate}></Column>
					</TablaDatos>

					<Dialog
						visible={productDialog}
						style={{ width: "850px" }}
						header={"Detalle " + tituloiter}
						modal={true}
						className='p-fluid'
						footer={productDialogFooter(hideDialog, saveProduct)}
						onHide={hideDialog}>
						<TabView>
							<TabPanel
								className='justify-content: flex-end;'
								// headerTemplate={tabHeaderIIespanol}
							>
								<div className='formgrid grid'>
									<div className='field col-6'>
										<label htmlFor='tip_ama'>
											Tipo de Agenda:
										</label>
										<Dropdown
											value={formData.tip_ama}
											onChange={(e) => {
												console.log(e.value);
												dispatch(
													setFormData({
														...formData,
														tip_ama: e.value,
													})
												);
											}}
											options={tipodeagenda}
											optionLabel='name'
											optionValue='code'
											placeholder='Seleccione'
										/>
									</div>
									<div className='field col-6'>
										<label htmlFor='fec_ama'>Fecha:</label>
										<Calendar
											dateFormat='yy-mm-dd'
											value={
												new Date(
													formData.fec_ama +
														"T00:00:00"
												)
											}
											onChange={(e) =>
												onInputChangeDate(e, "fec_ama")
											}
											required
											autoFocus></Calendar>
									</div>
								</div>

								<div className='formgrid grid'>
									<div className='field col-6'>
										<label htmlFor='cod_equ_ama'>
											Codigo / QR:
										</label>
										<span className='p-input-icon-right'>
											<i
												className='pi pi-qrcode'
												onClick={() => {
													openReedQR();
												}}
											/>
											<InputText
												id='cod_equ_ama'
												value={formData.cod_equ_ama}
												onChange={(e) =>
													onInputChange(
														e,
														"cod_equ_ama"
													)
												}
											/>
										</span>
									</div>
									<div className='field col-6'>
										<label htmlFor='sta_ama'>
											Status de Agenda:
										</label>
										<Dropdown
											value={formData.sta_ama}
											onChange={(e) => {
												console.log(e.value);
												dispatch(
													setFormData({
														...formData,
														sta_ama: e.value,
													})
												);
											}}
											options={statusagenda}
											optionLabel='name'
											optionValue='code'
											placeholder='Seleccione'
										/>
									</div>
								</div>
								<div className='field col '>
									<Leerqr
										openqr={openqr}
										qrset={setqrData}
										setopenqr={setopenqr}
									/>
								</div>

								<div className='field col '>
									<label htmlFor='des_ama'>Notas:</label>
									<InputTextarea
										id='des_ama'
										value={formData.des_ama}
										onChange={(e) =>
											onInputChange(e, "des_ama")
										}
										rows={3}
										cols={20}
									/>
								</div>

								{/* <pre>{JSON.stringify(formData, 2)}</pre> */}
								<div className='field col'>
									{formData?.id && (
										<ImagenCampo
											label='Imagen'
											formData={formData}
											CampoImagen='img_detalle'
											nombreCampo='demo'
											urlupload='/upload/images/galeria'
										/>
									)}
								</div>
								<Divider />
								{products.length > 0 && (
									<div className='carousel-demo'>
										<div className='card'>
											<Carousel
												value={products}
												numVisible={2}
												numScroll={1}
												responsiveOptions={
													responsiveOptions
												}
												itemTemplate={productTemplate}
												circular={true}
											/>
										</div>
									</div>
								)}
							</TabPanel>
						</TabView>
					</Dialog>
					<EliminarVentana
						deleteProductDialog={deleteProductDialog}
						product={formData.tit_not}
						hideDeleteProductDialog={hideDeleteProductDialog}
						deleteProduct={deleteProduct}
					/>
				</div>
			</div>
		</div>
	);
};
